module.exports = __webpack_public_path__ + "img/img-ticket-3.cecd2970.png";